import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearNotification } from "../actions/notifications";

class Notification extends Component{
	render(){
		return(
			<div className={`inm-global-notification notification is-${this.props.data.type}`} style={{display:(this.props.active ? 'block' : 'none')}}>
				<button className="delete" onClick={() => this.props.clearThis()}></button>
				<p><strong>{this.props.data.title}</strong></p>
				<div dangerouslySetInnerHTML={{__html: this.props.data.content}} />
			</div>
		)
	}

	componentWillReceiveProps(newprops) {
		if(newprops.active) {
			setTimeout(() => {
				this.props.clearThis();
			}, 5000);
		}
	}
}

function mapStateToProps(state) {
	const { notifications } = state;
	return { notifications }
}

const mapDispatchToProps = dispatch => {
	return {
		clearThis: () => {
			dispatch(clearNotification());
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification);


// WEBPACK FOOTER //
// ./src/elements/notification.jsx